import { createAsyncThunk } from '@reduxjs/toolkit';

// Services
import { DashboardService } from '../../services/dashboard.service';

// Slices & Thunks
import { DashboardSliceActions } from './dashboard.slice';
import { CounsellorsService } from '../../services/counsellors.service';

// Models
import { ICounsellorsFilters } from '../../interfaces/counsellors.interfaces';

export enum EDashboardThunks {
  FetchChartsInfo = 'DASHBOARD/fetchChartsInfo',
  FetchRevenueCounsellors = 'DASHBOARD/fetchRevenueCounsellors',
  FetchConsultationChartsInfo = 'DASHBOARD/fetchConsultationChartsInfo',
}

export const fetchChartsInfo = createAsyncThunk(
  EDashboardThunks.FetchChartsInfo,
  async (filters: { date?: string, worker_id?: number }, { dispatch }) => {
    dispatch(DashboardSliceActions.loadChartsInfo());
    const { error, charts } = await DashboardService.fetchChartsInfo(filters);
    if (!charts) {
      return dispatch(DashboardSliceActions.loadChartsInfoError(error ?? 'Error'));
    }
    return dispatch(DashboardSliceActions.loadChartsInfoSuccess(charts));
  }
);

export const fetchConsultationChartsInfo = createAsyncThunk(
  EDashboardThunks.FetchConsultationChartsInfo,
  async (_, { dispatch }) => {
    dispatch(DashboardSliceActions.loadChartsInfo());
    const { error, totals } = await DashboardService.fetchConsultationChartsInfo();
    if (!totals) {
      return dispatch(DashboardSliceActions.loadConsultationChartsInfoError(error ?? 'Error'));
    }
    return dispatch(DashboardSliceActions.loadConsultationChartsInfoSuccess(totals));
  }
);

export const fetchRevenueCounsellors = createAsyncThunk(
  EDashboardThunks.FetchRevenueCounsellors,
  async ({ filters, isFirstLoad = false }: {
    filters: ICounsellorsFilters,
    isFirstLoad?: boolean
  }, { dispatch }) => {
    dispatch(DashboardSliceActions.loadCounsellorsRequest({ isFirstLoad }));
    const { data, error } = await CounsellorsService.fetchCounsellors(filters);
    if (!data) {
      return dispatch(DashboardSliceActions.loadCounsellorsRequestFailure(error ?? 'Error'));
    }
    return dispatch(DashboardSliceActions.loadCounsellorsRequestSuccess({ data, isFirstLoad }));
  }
);
